import React from 'react';
import './index.css'

const TermsOfService = () => {
    return (
        <div className="context">
            <h1>
                Terms of Service
            </h1>
            <p className="text-bold">
                TERMS OF SERVICE
            </p>
            <p className="text-paragraph">
                These terms of service (the “Agreement”) form a legal agreement between you (“You”) and Vishwa Labs, a
                Cayman Islands company (the “Labs”, “We” or “Us”). The effective date of this Agreement is when You
                accept or are deemed to accept this Agreement. You are deemed to have accepted and agreed to this
                Agreement, and all terms herein including the Limitation of Liability and Indemnification provisions,
                when you access this website. If You are accessing this website on behalf of a business, your access
                constitutes the business’ acceptance of these terms
            </p>
            <p className="text-paragraph">
                Vishwa Labs, currently provides a method of access to, and certain information about, Vishwa network,
                an AI infrasturcture for autonomous finance ("Vishwa) as well as related content and functionality about Vishwa
                through websites located at Cayman Island(each, a “Site” and collectively, the “Sites”)We also currently provide
                access and information about Vishwa through our related technologies, including all of our existing and
                any updated or new features, functionalities and technologies (collectively, the “Service”).
            </p>
            <p className="text-paragraph">
                Vishwa and the suite of open-source code underlying it are contributed, used, and supported by a wide
                variety of participants. Labs is one of these many participants and contributes to the Vishwa ecosystem.
                To facilitate the early-stage development of the Vishwa ecosystem, Labs currently operates the Sites.
            </p>
            <p className="text-paragraph">
                PLEASE READ THESE TERMS OF SERVICE CAREFULLY, AS THEY CONTAIN AN AGREEMENT TO ARBITRATE AND OTHER
                IMPORTANT INFORMATION REGARDING YOUR LEGAL RIGHTS, REMEDIES, AND OBLIGATIONS. THE AGREEMENT TO ARBITRATE
                REQUIRES (WITH LIMITED EXCEPTION) THAT YOU SUBMIT CLAIMS YOU HAVE AGAINST US TO BINDING AND FINAL
                ARBITRATION, AND FURTHER (1) YOU WILL ONLY BE PERMITTED TO PURSUE CLAIMS AGAINST LABS ON AN INDIVIDUAL
                BASIS, NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY CLASS OR REPRESENTATIVE ACTION OR PROCEEDING, (2) YOU
                WILL ONLY BE PERMITTED TO SEEK RELIEF (INCLUDING MONETARY, INJUNCTIVE, AND DECLARATORY RELIEF) ON AN
                INDIVIDUAL BASIS, AND (3) YOU MAY NOT BE ABLE TO HAVE ANY CLAIMS YOU HAVE AGAINST US RESOLVED BY A JURY
                OR IN A COURT OF LAW.
            </p>
            <p className="text-bold">
                DISCLAIMER
            </p>
            <p className="text-paragraph">
                EACH SITE IS PROVIDED BY LABS ON AN “AS-IS” BASIS, WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR
                IMPLIED, INCLUDING, WITHOUT LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                PURPOSE, NON-INFRINGEMENT, OR THAT AVAILABILITY, ACCESSIBILITY, OR USE OF THE SITE WILL BE UNINTERRUPTED
                OR ERROR-FREE.
            </p>
            <p className="text-paragraph">
                We make no representation, warranty, guarantee, or undertaking regarding Vishwa or any of its products,
                services, or activities, whether express or implied, including but not limited to warranties of
                compliance, accuracy, reliability, validity, merchantability, fitness for a particular purpose, quality,
                availability, durability, and noninfringement, or as to any of it being uninterrupted, error free, free
                of harmful components, or secure. We are not liable for, or in connection with, any actions,
                proceedings, claims, damages, expenses or other liabilities, whether in an action of contract, tort or
                otherwise, arising from, related to or in connection with Vishwa or any of its products, services, or
                activities, or the use or dealings in or with any of them or in reliance thereon.
            </p>
            <p className="text-paragraph">
                We are not, do not speak for, and cannot bind, the Vishwa community. Vishwa community is a collection of
                independent contributors to Vishwa. Labs is a separate, independent entity. While we currently
                contribute to the Vishwa ecosystem, we do not speak for the community, and cannot contractually bind it
                in any manner.
            </p>
            <p className="text-paragraph">
                We do not endorse third parties or third party information. Any time we link to, quote or otherwise
                reference a third party or reproduce or incorporate their information, content or material, it is solely
                for informational purposes. You should not assume that we have verified the accuracy of, or endorse in
                any way, such information, content or materials.
            </p>
            <p className="text-bold">
                Your Privacy
            </p>
            <p className="text-paragraph">
                For more information regarding our collection, use and disclosure of personal data and certain other
                data, please see our Privacy Policy (the “Privacy Policy”). By using the Service, you consent to our
                collection, use and disclosure of Personal Data and other data as outlined therein. The Privacy Policy
                is hereby incorporated by reference into these Terms of Service.
            </p>
            <p className="text-bold">
                Changes to Terms
            </p>
            <p className="text-paragraph">
                We reserve the right to change the Terms at any time. All changes are effective immediately when we post
                them. Your continued use of the Site following the posting of revised Terms means that you accept and
                agree to the changes. You are expected to check this page frequently so you are aware of any changes, as
                they are binding on you
            </p>
            <p className="text-bold">
                Intellectual Property Rights
            </p>
            <p className="text-paragraph">
                The Sites and their entire contents, features, and functionality (including but not limited to all
                information, software, text, displays, images, video and audio, and the design, selection, and
                arrangement thereof), are owned by us, our licensors or other providers of such material and are
                protected by copyright, trademark, patent, trade secret, and other intellectual property or proprietary
                rights laws. Neither these Terms (nor your access to the Sites) transfers to you or any third party any
                rights, title or interest in or to such intellectual property rights, except as indicated otherwise.
            </p>
            <p className="text-bold">
                Access to the Sites
            </p>
            <p className="text-paragraph">
                You may only access or use the Site or accept the Terms if you are an individual of legal age (at least
                18) to form a binding contract. If you are agreeing to the Terms on behalf of an organization or entity,
                you represent and warrant that you are authorized to agree to the Terms on that organization’s or
                entity’s behalf and bind them to the Terms (in which case, the references to “you” and “your” in the
                Terms, except for in this sentence and in the paragraph directly above, refer to that organization or
                entity).
            </p>
            <p className="text-paragraph">
                For the avoidance of doubt, you will comply with all applicable sanctions laws, regulations and rules,
                including but not limited to, those administered by the U.S. Department of the Treasury’s Office of
                Foreign Assets Control (“OFAC”), and any other applicable jurisdictions. The Sites may not be used: (i)
                in the Crimea region of Ukraine, Cuba, Iran, North Korea, or Syria; (ii) by or for the specific benefit
                of any individual or entity on the Specially Designated Nationals and Blocked Persons (“SDN”) List
                maintained by OFAC, (iii) any entity 50% or more owned in the aggregate by any such SDN(s); or (v) for
                any other use requiring a license or other governmental approval. If Labs determines that you have
                breached your obligation under this section, we shall block your access to the Service and any interests
                in property as required by law, if continued Service could result in Labs being in violation, or subject
                to negative consequences, under the Sanctions Rules.
            </p>
            <p className="text-bold">
                License
            </p>
            <p className="text-paragraph">
                Subject to these Terms, you are hereby granted a non-transferable, non-exclusive, revocable, limited
                license to use and access the Site and the Services solely for your own personal, non-commercial use,
                subject to the following restrictions: (a) you shall not license, sell, rent, lease, transfer, assign,
                distribute, host, or otherwise commercially exploit the Site, whether in whole or in part, or any
                content displayed on the Sites; and (b) you shall not modify, make derivative works of, disassemble,
                reverse compile or reverse engineer any part of the Sites. All copyright and other proprietary notices
                on the Sites (or on any content displayed on the Sites) must be retained on all copies thereof.
            </p>
            <p className="text-bold">
                Prohibited Uses
            </p>
            <p className="text-paragraph">
                You may use the Sites only for lawful purposes and in accordance with these Terms. You agree not to use
                the Sites:
            </p>
            <ul className="text-paragraph">
                <li>
                    in any way that violates any applicable federal, state, local, or international law or regulation,
                    including, without limitation, any applicable sanctions laws, export control laws, securities laws,
                    anti-money laundering laws, privacy laws;
                </li>
                <li>
                    use any device, software or routine that interferes with the proper working of any Site;
                </li>
                <li>
                    attempt to probe, scan or test the vulnerability of Vishwa or otherwise seek to interfere with or
                    compromise the integrity, security, or proper functioning of Vishwa;
                </li>
                <li>
                    attempt to interfere with the proper working of the Sites, or interfere with, damage, or disrupt any
                    parts of the Sites, the server(s) on which the Sites is stored, or any server, computer or database
                    connected to the Sites;
                </li>
                <li>
                    further or promote any criminal activity or enterprise or provide instructional information about
                    illegal activities; or
                </li>
                <li>
                    encourage or enable any other individual to do any of the foregoing.
                </li>
            </ul>
            <p className="text-paragraph">
                If Labs determines that you have breached your obligation under this section, we shall block your access
                to the Service and any interests in property as required by law. If you are blocked by Labs from
                accessing the Service (including by blocking your IP address), you agree not to implement any measures
                to circumvent such blocking (e.g., by masking your IP address or using a proxy IP address or virtual
                private network).
            </p>
            <p className="text-bold">
                Indemnification
            </p>
            <p className="text-paragraph">
                To the fullest extent permitted by applicable laws, you agree to indemnify, defend and hold harmless
                Labs, as well as its affiliates and service providers, and each of their respective past, present and
                future officers, directors, members, employees, consultants, representatives and agents, and each of
                their respective successors and assigns (the “Indemnified Parties”) from and against all actual or
                alleged third party claims, damages, awards, judgments, losses, liabilities, obligations, taxes,
                penalties, interest, fees, expenses (including, without limitation, attorneys’ fees and expenses) and
                costs (including, without limitation, court costs, costs of settlement and costs of pursuing
                indemnification and insurance), of every kind and nature whatsoever, whether known or unknown, foreseen
                or unforeseen, matured or unmatured, or suspected or unsuspected, in law or equity, whether in tort,
                contract or otherwise (collectively, “Claims”), including, but not limited to, damages to property or
                personal injury, that are caused by, arise out of or are related to: (a) your use of the Site; (b) your
                violation of these Terms or applicable law; (c) your violation of the rights of a third party; and (d)
                your negligence or willful misconduct. You agree to promptly notify us of any third party Claims and
                cooperate with the Indemnified Parties in defending such Claims. You further agree that the Indemnified
                Parties shall have the right to control the defense or settlement of any third party Claims as they
                relate to us, if it so chooses.
            </p>
            <p className="text-bold">
                Limitation of Liability
            </p>
            <p className="text-paragraph">
                YOU EXPRESSLY UNDERSTAND AND AGREE THAT THE LABS PARTIES WILL NOT BE LIABLE FOR ANY INDIRECT,
                INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY DAMAGES, OR DAMAGES FOR LOSS OF PROFITS INCLUDING DAMAGES
                FOR LOSS OF GOODWILL, USE, OR DATA OR OTHER INTANGIBLE LOSSES (EVEN IF THE LABS PARTIES HAVE BEEN
                ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), WHETHER BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT
                LIABILITY, OR OTHERWISE, RESULTING FROM: (A) THE USE OR THE INABILITY TO USE THE SERVICE; (B) THE COST
                OF PROCUREMENT OF SUBSTITUTE GOODS AND SERVICES RESULTING FROM ANY GOODS, DATA, INFORMATION, OR SERVICES
                PURCHASED OR OBTAINED OR MESSAGES RECEIVED OR TRANSACTIONS ENTERED INTO THROUGH OR FROM THE SERVICE; (C)
                UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA; (D) STATEMENTS OR CONDUCT OF ANY
                THIRD PARTY ON THE SERVICE; (E) INTERRUPTION OR CESSATION OF FUNCTION RELATED TO THE Vishwa; (F) BUGS,
                VIRUSES, TROJAN HORSES, OR THE LIKE THAT MAY BE TRANSMITTED TO OR THROUGH Vishwa; (G) ERRORS OR
                OMISSIONS IN, OR LOSS OR DAMAGE INCURRED AS A RESULT OF THE USE OF, ANY CONTENT MADE AVAILABLE THROUGH
                Vishwa OR (H) ANY OTHER MATTER RELATING TO THE SERVICE. IN NO EVENT WILL THE LABS PARTIES’ TOTAL
                LIABILITY TO YOU FOR ALL DAMAGES, LOSSES, OR CAUSES OF ACTION EXCEED THE AMOUNT YOU HAVE PAID LABS IN
                THE LAST SIX (6) MONTHS, OR, IF GREATER, ONE HUNDRED DOLLARS ($100).
            </p>
            <p className="text-paragraph">
                SOME JURISDICTIONS DO NOT ALLOW THE DISCLAIMER OR EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR
                EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, SOME OF THE ABOVE
                LIMITATIONS SET FORTH ABOVE MAY NOT APPLY TO YOU OR BE ENFORCEABLE WITH RESPECT TO YOU. IF YOU ARE
                DISSATISFIED WITH ANY PORTION OF THE SERVICE OR WITH THESE TERMS OF SERVICE, YOUR SOLE AND EXCLUSIVE
                REMEDY IS TO DISCONTINUE USE OF THE SERVICE.
            </p>
            <p className="text-bold">
                Dispute Resolution
            </p>
            <p className="text-paragraph">
                Please read carefully the following arbitration agreement (this “Arbitration Agreement”). It requires
                you to arbitrate disputes with us and limits the manner in Cayman Arbitration Law 2012 which you can
                seek relief from us.
            </p>
            <p>
                Applicability of this Arbitration Agreement
            </p>
            <p className="text-paragraph">
                You agree that any dispute, claim, or request for relief relating in any way to the Terms or to any
                aspect of your relationship with us, will be resolved by binding arbitration, rather than in court,
                except that (i) you may assert claims or seek relief in small claims court if your claims qualify, and
                (ii) you or we may seek equitable relief in court for infringement or other misuse of intellectual
                property rights (such as trademarks, trade dress, domain names, trade secrets, copyrights, and patents).
                This Arbitration Agreement shall apply, without limitation, to all disputes or claims and requests for
                relief that arose or were asserted before the effective date of the Terms or any prior version of the
                Terms.
            </p>
            <p className="text-paragraph">
                Arbitration rules and forum. The Cayman Arbitration Law 2012 governs the interpretation and enforcement
                of this Arbitration Agreement. To begin an arbitration proceeding, you must send a letter requesting
                arbitration and describing your dispute or claim or request for relief to official@vishwanetwork.xyz.
            </p>
            <p className="text-bold">
                Authority of arbitrator
            </p>
            <p className="text-paragraph">
                The arbitrator shall have exclusive authority to (i) determine the scope and enforceability of this
                Arbitration Agreement, and (ii) resolve any dispute related to the interpretation, applicability,
                enforceability or formation of this Arbitration Agreement including, but not limited to, any assertion
                that all or any part of this Arbitration Agreement is void or voidable, whether a claim is subject to
                arbitration, and any dispute regarding the payment of arbitration administrative or arbitrator fees
                (including the timing of such payments and remedies for nonpayment). The arbitrator will decide the
                rights and liabilities, if any, of you and us. The arbitration proceeding will not be consolidated with
                any other matters or joined with any other cases or parties, provided that the arbitrator shall also be
                empowered to consolidate claims raised between the same parties to a single arbitration proceeding. The
                arbitrator shall have the authority to grant motions dispositive of all or part of any claim. The
                arbitrator shall have the authority to award monetary damages and to grant any non-monetary remedy or
                relief available to an individual under applicable law, the arbitral forum’s rules, and this Agreement
                (including the Arbitration Agreement). The arbitrator shall issue a written award and statement of
                decision describing the essential findings and conclusions on which the award is based, including the
                calculation of any damages awarded. The arbitrator has the same authority to award relief on an
                individual basis that a judge in a court of law would have. The award of the arbitrator is final and
                binding upon you and us. No arbitration award or decision will have any preclusive effect as to issues
                or claims in any dispute with anyone who is not a named party to the arbitration.
            </p>
            <p className="text-bold">
                Waiver of jury trial
            </p>
            <p className="text-paragraph">
                YOU HEREBY WAIVE ANY CONSTITUTIONAL AND STATUTORY RIGHTS TO SUE IN COURT AND HAVE A TRIAL IN FRONT OF A
                JUDGE OR A JURY.
            </p>
            <p className="text-paragraph">
                You and we are instead electing that all disputes, claims, or requests for relief shall be resolved by
                arbitration under this Arbitration Agreement, except as specified in this Agreement. An arbitrator can
                award on an individual basis the same damages and relief as a court and must follow this Arbitration
                Agreement as a court would. However, there is no judge or jury in arbitration, and court review of an
                arbitration award is subject to very limited review.
            </p>
            <p className="text-bold">
                Waiver of class or other non-individualized relief
            </p>
            <p className="text-paragraph">
                ALL DISPUTES, CLAIMS, AND REQUESTS FOR RELIEF WITHIN THE SCOPE OF THIS ARBITRATION AGREEMENT MUST BE
                ARBITRATED ON AN INDIVIDUAL BASIS AND NOT ON A CLASS OR COLLECTIVE BASIS, ONLY INDIVIDUAL RELIEF IS
                AVAILABLE, AND CLAIMS OF MORE THAN ONE USER CANNOT BE ARBITRATED OR CONSOLIDATED WITH THOSE OF ANY OTHER
                USER. If a decision is issued stating that applicable law precludes enforcement of any of this section’s
                limitations as to a given dispute, claim, or request for relief, then such aspect must be severed from
                the arbitration and brought into the courts of the Cayman Island. All other disputes, claims, or
                requests for relief shall be arbitrated.
            </p>
            <p className="text-bold">
                30-day right to opt out
            </p>
            <p className="text-paragraph">
                You have the right to opt out of the provisions of this Arbitration Agreement by sending written notice
                of your decision to opt out to official@vishwanetwork.xyz within 30 days after you first access the
                Service. Your notice must include your name and address, the Web3 wallet address used to connect to the
                Site (if applicable), and an unequivocal statement that you want to opt out of this Arbitration
                Agreement. If you opt out of this Arbitration Agreement, (i) all other parts of this Arbitration
                Agreement will continue to apply to you, and (ii) we will not be bound by this Arbitration Agreement.
                Opting out of this Arbitration Agreement has no effect on any other arbitration agreements that you may
                currently have, or may enter in the future, with us.
            </p>
            <p className="text-bold">
                Severability
            </p>
            <p className="text-paragraph">
                Except as provided in this Agreement (Waiver of class or other non-individualized relief), if any part
                or parts of this Arbitration Agreement are held by a court or other tribunal of competent jurisdiction
                to be invalid, illegal, or unenforceable for any reason, such specific part or parts shall be eliminated
                or limited to the minimum extent such that the remainder of the Arbitration Agreement shall continue in
                full force and effect.
            </p>
            <p className="text-bold">
                Survival of Agreement
            </p>
            <p>
                This Arbitration Agreement will survive the termination of your relationship with us.
            </p>
            <p className="text-bold">
                Modification
            </p>
            <p className="text-paragraph">
                Notwithstanding any provision in the Terms to the contrary, we agree that if we make any future material
                change to this Arbitration Agreement, you may reject that change within 30 days of such change becoming
                effective by writing us at legal@Vishwa.xyz and expressly opting out of this Arbitration Agreement.
            </p>
            <p className="text-bold">
                Governing Law
            </p>
            <p className="text-paragraph">
                These Terms are governed by and will be construed under the laws of the Cayman Islands, excluding its
                body of law controlling conflict of laws. You agree that the Sites shall be deemed to be based solely in
                the Cayman Islands, and that although the Sites may be available in other jurisdictions, its
                availability does not give rise to general or specific personal jurisdiction in any forum outside the
                Cayman Islands. Any arbitration conducted pursuant to this Agreement shall be governed by the Cayman
                Arbitration Law 2012. You agree that any judicial proceeding will be brought in the courts located in
                the Cayman Islands.
            </p>
            <p className="text-bold">
                Conflict of Provisions
            </p>
            <p className="text-paragraph">
                In the event that there exists a conflict between any term, condition or provision contained within
                these Terms, and in any term, condition, or provision contained within any other specific part or
                feature, the term, condition, or provision contained in such specific part or feature will control.
            </p>
            <p className="text-bold">
                Severability
            </p>
            <p className="text-paragraph">
                Without limiting Severability in Arbitration Agreement,, if any part or parts of the Terms is held by a
                court or other tribunal of competent jurisdiction to be invalid, illegal, or unenforceable for any
                reason, such part or parts shall be eliminated or limited to the minimum extent such that the remaining
                provisions of the Terms will continue in full force and effect.
            </p>
            <p className="text-paragraph">
                Additional Terms for Bridge
            </p>
            <p className="text-paragraph">
                Please note that your access to ……………., or ………………. (the “Interface”) and the use thereof is subject to
                these additional terms (the “Interface Terms”). If you do not agree to all of the Interface terms in
                their entirety, you may not use the interface in any manner.
            </p>
            <ul className="text-paragraph">
                <li>
                    Compliance with Law. You represent and warrant that you will comply with all laws that apply to you,
                    your use of the Interface, and your actions and omissions that relate to the Interface. If your use
                    of the Interface is prohibited by applicable laws, then you aren’t authorized to use the Interface.
                    We will not be responsible for your using the Interface in a way that is a violation of any law.
                    Without limiting the foregoing, you represent and warrant that you are not, and for the duration of
                    the time you use the Interface will not be (a) the subject of economic or trade sanctions
                    administered or enforced by any governmental authority or otherwise designated on any list of
                    prohibited or restricted parties (including but not limited to the United Nations Security Council,
                    the European Union, His Majesty’s Treasury, and U.S. Department of Treasury), or (b) a citizen,
                    resident, or organized in a jurisdiction or territory that is the subject of comprehensive
                    country-wide, territory-wide, or regional economic sanctions by the United Nations, European Union,
                    any EU country, UK Treasury, or the United States, including without limitation Cuba, the Crimea,
                    Donetsk, and Luhansk regions of Ukraine, Iran, North Korea, Russia, Syria, or Yemen. If at any point
                    the above is no longer true, you must immediately cease using the Interface.
                </li>
                <li>
                    Interface vs. Protocol. The Interface facilitates your ability to access Vishwa, a layer 2 rollup
                    protocol on the Bitcoin blockchain (the “Protocol”). The Interface is distinct from the Protocol. It
                    provides one, but not the exclusive, means of accessing the Protocol. The Protocol is public,
                    permissionless, and runs on open-source self-executing smart contracts. The Protocol enables people
                    to do various things, such as processing Bitcoin transactions more efficiently and interacting with
                    smart contract-based applications (“dApps”). The Interface, on the other hand, enables you to
                    initiate messages to the Protocol to bridge digital assets between the Bitcoin and Vishwa public
                    blockchains.
                </li>
                <li>
                    Accessing the Interface. To access the Interface you must use non-custodial wallet software (a “Web3
                    wallet”), which constructs and broadcasts the data (“transactions”) that allows you to interact with
                    the Protocol. By using your Web3 wallet in connection with accessing the Interface, you agree that
                    you are using the Web3 wallet under the terms and conditions of the applicable provider of the Web3
                    wallet. No Web3 wallet is created by, operated by, maintained by, or affiliated with us.
                    Accordingly, we do not have custody or control over the contents of your Web3 wallet and we have no
                    ability to retrieve or transfer its contents. Your relationship with any given Web3 wallet provider
                    is governed by the applicable terms of service of that third party, not the Interface Terms.
                </li>
                <li>
                    Assumption of risk. By using the Interface, you (a) represent that you are sophisticated enough to
                    understand the various inherent risks of using cryptographic and public blockchain-based systems,
                    including but not limited to the Interface, the Protocol, and digital assets, and (b) acknowledge
                    and accept all such risks, and agree that we make no representations or warranties (expressly or
                    implicitly) regarding, and that you will not hold us liable for those risks, including but not
                    limited to the risks described below, any or all of which could lead to losses and damages,
                    including the total and irrevocable loss of your assets. These risks include, but are not limited
                    to:
                    <ul style={{listStyle: 'circle'}}>
                        <li>
                            Wallet security and safekeeping. You are solely responsible for the safeguarding and
                            security of your Web3 wallets. If you lose your wallet seed phrase, private keys, or
                            password, you may be forever unable to access your digital assets. Any unauthorized access
                            to your wallet by third parties could result in the loss or theft of your digital assets. We
                            have no involvement in, or responsibility for, storing, retaining, securing or recovering
                            your Web3 wallet seed phrases, private keys, or passwords, or for any unauthorized access to
                            your Web3 wallet.
                        </li>
                        <li>
                            Blockchain technology. Public blockchains, and the technology underlying and interacting
                            with cryptographic and public blockchain-based systems, are experimental, inherently risky,
                            and subject to change. Among other risks, bugs, malfunctions, cyberattacks, or changes to a
                            particular public blockchain (e.g., via forks) could disrupt these technologies irreparably.
                            There is no guarantee that any of these technologies will not become unavailable, degraded,
                            or subject to hardware or software errors, operational or technical difficulties,
                            denial-of-service attacks, other cyberattacks, or other problems requiring maintenance,
                            interruptions, delays, or errors.
                        </li>
                        <li>
                            Network cost and performance. The cost, speed, and availability of transacting on public
                            blockchain systems are subject to significant variability. There is no guarantee that any
                            transfer will be confirmed or transferred successfully.
                        </li>
                        <li>
                            Blockchain transactions and smart contract execution. Public blockchain-based transactions
                            (including but not limited to transactions automatically executed by smart contracts) are
                            generally considered irreversible when confirmed. Any transaction that will interact with
                            smart contracts or be recorded on a public blockchain must be recorded with extreme caution.
                        </li>
                        <li>
                            Digital assets. The markets for digital assets are nascent and highly volatile due to
                            various risk factors including (but not limited to) adoption, speculation, technology,
                            security, and regulation. Digital assets and their underlying blockchain networks are
                            complex emerging technologies that may be subject to delays, halts or go offline as a result
                            of errors, forks, attacks or other unforeseeable reasons. Anyone can create a digital asset,
                            including fake versions of existing digital assets and digital assets that falsely claim to
                            represent projects. So-called stablecoins may not be as stable as they purport to be, may
                            not be fully or adequately collateralized, and may be subject to panics and runs. You are
                            solely responsible for understanding the risks specific to each digital asset that is
                            relevant to you.
                        </li>
                        <li>
                            Bridging. In addition to being an especially novel and untested implementation of blockchain
                            technology in general, cross-blockchain bridging technology has historically been, and may
                            in the future be, the subject of numerous cyberattacks and exploits, including without
                            limitation, hacks that exploit a vulnerability in the associated software, hardware, systems
                            or other equipment or social engineering to gain control of the any bridge components,
                            wallets, smart contracts or other related systems.
                        </li>
                        <li>
                            Control of the Protocol. The Protocol is subject to periodic upgrades, which may introduce
                            other risks, bugs, malfunctions, cyberattack vectors, or other changes to the Protocol that
                            could disrupt the operation of the Interface, the functionality of bridging, your ability to
                            access bridged digital assets, or otherwise cause you damage or loss.
                        </li>
                        <li>
                            Third Party Risks. Third-party products carry their own individual, oftentimes highly
                            significant risks. When you use the Interface to interact with any third-party products, you
                            are subject to all of those risks.
                        </li>
                        <li>
                            Legislative and regulatory risks. Legislative and regulatory risks. Digital assets,
                            blockchain technology, and any related software and services are subject to legal and
                            regulatory uncertainty in many jurisdictions. Legislative and regulatory changes or actions
                            may adversely affect the usage, transferability, transactability and accessibility of
                            digital assets, bridging, the Protocol, or the Interface.
                        </li>
                    </ul>
                </li>
                <li>
                    Information Only. You agree that the Interface Terms (or any information provided by or obtained
                    from the Interface) are for informational purposes only, are not intended to be relied upon for
                    professional advice of any sort, and is not a substitute for information from experts or
                    professionals in the applicable area. You should not take, or refrain from taking, any action or
                    decision based on any information contained in the Interface. If, and before you make any financial,
                    legal, or other decisions involving the Interface, you should seek independent professional advice
                    from an individual who is licensed and qualified in the area for which such advice would be
                    appropriate.
                </li>
                <li>
                    Release of claims. You expressly agree that you assume all risks in connection with your use of the
                    Interface and your interaction with the Protocol. You further expressly waive and release Matter
                    Labs, as well as its affiliates and service providers, and each of their respective past, present
                    and future officers, directors, members, employees, consultants, representatives and agents, and
                    each of their respective successors and assigns from any and all liability, claims, causes of
                    action, or damages arising from or in any way relating to your use of the Interface or your
                    interaction with the Protocol.
                </li>
            </ul>
            <p className="text-bold">
                Entire Agreement
            </p>
            <p className="text-paragraph">
                These Terms of Service, our Privacy Policy and Cookies Policy constitute the sole and entire agreement
                between you and us.
            </p>
        </div>
    );
};

export default TermsOfService;